import React from "react";
import AppRouter from "./routers/AppRouter";

function JournalApp() {
	return (
		<>
			<AppRouter />
		</>
	);
}

export default JournalApp;
